var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0V3.92453C22.6691 3.92453 28.0755 9.3309 28.0755 16C28.0755 22.6691 22.6691 28.0755 16 28.0755V32Z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32V28.0755C9.3309 28.0755 3.92453 22.6691 3.92453 16C3.92453 9.3309 9.3309 3.92453 16 3.92453V0Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92456 15.9998C3.92456 9.3307 9.33092 3.92433 16 3.92432V11.2702L11.2704 15.9998L16 20.7293V28.0753C9.33092 28.0752 3.92456 22.6689 3.92456 15.9998Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0755 15.9998C28.0755 22.6689 22.6691 28.0753 16 28.0753V20.7293L20.7296 15.9998L16 11.2702V3.92432C22.6691 3.92432 28.0755 9.33069 28.0755 15.9998Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 20",
    x: 16,
    y: 22.4404,
    width: 2.81761,
    height: 1.91195,
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26",
    x: 16,
    y: 7.54736,
    width: 2.81761,
    height: 1.91195,
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22",
    x: 24.4529,
    y: 16,
    width: 2.81761,
    height: 1.91195,
    transform: "rotate(90 24.4529 16)",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24",
    x: 9.45911,
    y: 16,
    width: 2.81761,
    height: 1.91195,
    transform: "rotate(90 9.45911 16)",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 21",
    x: 13.1824,
    y: 22.4404,
    width: 2.81761,
    height: 1.91195,
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 27",
    x: 13.1824,
    y: 7.54736,
    width: 2.81761,
    height: 1.91195,
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23",
    x: 24.4529,
    y: 13.1826,
    width: 2.81761,
    height: 1.91195,
    transform: "rotate(90 24.4529 13.1826)",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 25",
    x: 9.45911,
    y: 13.1826,
    width: 2.81761,
    height: 1.91195,
    transform: "rotate(90 9.45911 13.1826)",
    fill: "#FDBF00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.98951d10b1790ab8851d9cbb54b01031.svg";
export { ForwardRef as ReactComponent };